import { reportService } from '../request'

/**
 * 创建报表模板
 * @param {Object} templateData 模板数据 {name, content, creator_id}
 * @returns {Promise} 返回Promise对象
 */
export const createTemplate = (templateData) => {
  return reportService.post('/report-template', templateData)
}

/**
 * 获取所有报表模板
 * @param {Object} params 查询参数 {page, size}
 * @returns {Promise} 返回Promise对象
 */
export const getAllTemplates = (params = {}) => {
  return reportService.get('/report-template', { params })
}

/**
 * 根据ID获取报表模板
 * @param {Number} id 模板ID
 * @returns {Promise} 返回Promise对象
 */
export const getTemplateById = (id) => {
  return reportService.get(`/report-template/${id}`)
}

/**
 * 更新报表模板
 * @param {Number} id 模板ID 
 * @param {Object} templateData 更新后的模板数据
 * @returns {Promise} 返回Promise对象
 */
export const updateTemplate = (id, templateData) => {
  return reportService.put(`/report-template/${id}`, templateData)
}

/**
 * 删除报表模板
 * @param {Number} id 模板ID
 * @returns {Promise} 返回Promise对象
 */
export const deleteTemplate = (id) => {
  return reportService.delete(`/report-template/${id}`)
}

/**
 * 获取指定创建人的所有报表模板
 * @param {Number} creatorId 创建人ID
 * @returns {Promise} 返回Promise对象
 */
export const getTemplatesByCreator = (creatorId) => {
  return reportService.get(`/report-template/creator/${creatorId}`)
}

/**
 * 搜索报表模板
 * @param {Object} params 搜索参数 {keyword, type}
 * @returns {Promise} 返回Promise对象
 */
export const searchTemplates = (params = {}) => {
  return reportService.get('/report-template', { params })
}

/**
 * 获取按旗县分组的模板列表
 * @returns {Promise} 返回Promise对象
 */
export const getTemplatesGroupedByDepartment = () => {
  return reportService.get('/report-template/grouped-by-department')
}
